(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "KarcherSubscriptionsAlarmsViewModel",
      karcherSubscriptionsAlarmsViewModelFactory
    );

  /** @ngInject */
  function karcherSubscriptionsAlarmsViewModelFactory($translate) {
    function KarcherSubscriptionsAlarmsViewModel() {
      this.subscriptionsData = [];
    }

    KarcherSubscriptionsAlarmsViewModel.prototype.destroy = function () {};

    KarcherSubscriptionsAlarmsViewModel.prototype.refreshSubscriptionsList =
      function (data) {
        if (data.length === 0) {
          this.subscriptionsData = [];
          this.subscriptionsData.push({
            siteName: $translate.instant("NOTHING_TO_DISPLAY"),
            hideButton: true
          });
        } else {
          this.subscriptionsData = data;
        }
      };

    return KarcherSubscriptionsAlarmsViewModel;
  }
})();
